import { Box, Divider, Flex, Text } from '@podiumhq/design-system';

const SelectedPlanSummaryDiscountContent = ({ discountPrice = {} }) =>
  discountPrice?.discountPrice ? (
    <>
      <Flex justify="space-between">
        <Text {...lightTextStyles}>Subtotal</Text>
        <Text {...lightTextStyles}>${discountPrice.discountPrice}</Text>
      </Flex>

      <Flex justify="space-between" mt="15px">
        <Box display="inline-flex">
          <Text mt="2px" {...lightTextStyles}>
            Welcome Discount
          </Text>
          <Box bg="grey.lightest" borderRadius="4px" padding="2px 7px" ml="7px">
            <Text {...lightTextStyles}>
              {discountPrice.discountPercentage}% off
            </Text>
          </Box>
        </Box>
        <Text {...lightTextStyles}>
          -${(discountPrice.price * discountPrice.discountPercentage) / 100}
        </Text>
      </Flex>
      <Divider mt="24px" mb="20px" />
    </>
  ) : null;

const lightTextStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
};

export default SelectedPlanSummaryDiscountContent;
